// Vendor
import $ from 'jquery';
import 'tooltipster';
import 'jquery-touchswipe';
// Custom
import autocomplete from '../../../vendor/webcaravel/gk-framework/resources/js/app/autocomplete.custom.js';
import magnificPopup from '../../../vendor/webcaravel/gk-framework/resources/js/app/magnific-popup.custom.js';
import notifyCustom from "../../../vendor/webcaravel/gk-framework/resources/js/app/notify.custom";
import GKF from '../../../vendor/webcaravel/gk-framework/resources/js/app/gk-framework';

// Import jQuery+plugins
window.$ = window.jQuery = $;
autocomplete($);
magnificPopup($);
notifyCustom($);

// Initialize GKF
GKF.init(
    [
        ["Meine Genusspunkte", "/user/genusspunkte", "recipes"],
        true,
        ["Meine Kochbücher", "/user/user-bookmark/brz", "book"],
        ["Meine Cocktailkarten", "/user/user-bookmark/bck", "glass2"],
        ["Meine Artikel", "/user/user-bookmark/bar", "file"],
        true,
        ["Einkaufslisten", "/user/einkaufsliste", "list"],
        true,
        ["Rezept eintragen", "/user/rezept/eintragen/rezept", "edit"],
        ["Cocktail eintragen", "/user/rezept/eintragen/cocktail", "edit"],
        true,
        ["User Einstellungen", "/user/profil/edit", "address-book"],
        ["Mein Userprofil", "/user/profil", "profile"],
        ["User suchen", "/user/suche", "users"],
        ["E-Mail Abos", "/user/mailsetting", "mail"],
        true,
        ["Abmelden", "/gk-framework/auth/logout", "exit"]
    ],
    function() {
        APP.pageViewActions.push(function(){
            AppAd.reloadAds();
        });
    }
)
